import React from "react";
import { BsFillSendFill } from "react-icons/bs";

const sampleQuestions = [
  {
    category: "Pricing",
    query: "Which products at Koramangala Dark Store are priced higher than Zepto and Blinkit? Suggest price adjustments within margin guardrails.",
  },
  {
    category: "Promotion",
    query: "Any perishable products expiring within 3 days at Andheri Dark Store that need markdown promotions to avoid wastage?",
  },
  {
    category: "Replenishment",
    query: "Which SKUs at Whitefield Dark Store have stock below reorder point with no pending orders? Recommend order quantities.",
  },
  {
    category: "Inventory Rebalancing",
    query: "Koramangala store has excess Organic Quinoa (8 days cover) but Whitefield is low on Dairy. Can we transfer stock between stores to balance inventory?",
  },
  {
    category: "Placement",
    query: "Which long-tail products are underperforming at Gurugram Dark Store? Should we delist any to free shelf space for high-demand items?",
  },
  {
    category: "Daily Actions",
    query: "Give me today's top 5 priority actions across all dark stores covering stockout risks, expiry markdowns, and competitive pricing gaps.",
  },
];

const ScenarioCards = ({ onCardClick }) => {
  return (
    <div className="w-full max-w-3xl">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {sampleQuestions.map((item, idx) => (
          <button
            key={idx}
            onClick={() => onCardClick(item.query)}
            className="flex items-start justify-between gap-3 p-4 bg-white border border-slate-200 rounded-xl text-left hover:border-slate-400 hover:shadow-sm transition group"
          >
            <div className="flex-1 min-w-0">
              <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wide mb-1">
                {item.category}
              </p>
              <p className="text-[13px] text-slate-700 group-hover:text-slate-900 leading-snug">
                {item.query}
              </p>
            </div>
            <BsFillSendFill
              size={12}
              className="text-slate-300 group-hover:text-emerald-500 flex-shrink-0 mt-1 transition"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScenarioCards;
